import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface ReservationsState {
  error: any
  success: any
  dictionaries: any[]
  reservationsExpiryTimes: any[]
}

export const useReservationsStore = defineStore('reservations', {
  state: (): ReservationsState => ({
    error: null,
    success: null,
    dictionaries: [],
    reservationsExpiryTimes: [],
  }),

  getters: {
    getDictionaryAdd: (state) => state.success,
    getDictionaryAddError: (state) => state.error,
    getDictionaryFetch: (state) => state.dictionaries,
    getReservationExpiryTimes: (state) => state.reservationsExpiryTimes,
    getAddStatus: (state) => state.success,
    getAddError: (state) => state.error,
  },

  actions: {
    async fetchDictionary() {
      try {
        const response = await api().get('namesearch/dictionary')
        this.dictionaries = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async addDictionary(data: any) {
      try {
        const response = await api().post('namesearch/dictionary', data)
        this.success = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async addReservationExpiryTime(data: any) {
      try {
        const response = await api().post('reservation/settings/expiry', data)
        this.success = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchReservationExpiryTimes() {
      try {
        const response = await api().get('reservation/settings/expiry')
        this.reservationsExpiryTimes = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async addReservationNotificationTime(data: any) {
      try {
        const response = await api().post('reservation/settings/notifications', data)
        this.success = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },
  },
})
